/* app/js/src/components/common/separate-time-picker/separate-time-picker.component.scss */
:host {
  display: flex;
  flex-direction: column;
  padding: 0 10px;
  margin-bottom: 5px;
}
.set-time {
  height: 2.2em;
  line-height: 2.2em;
  color: #879baf;
  font-size: 12px;
  text-transform: uppercase;
}
.time-parts {
  display: flex;
  flex-direction: row;
}
.time-parts .divider {
  height: 32px;
  width: 30px;
  display: flex;
  padding: 9px 0 0 12px;
  flex-direction: column;
  justify-content: space-evenly;
}
/*# sourceMappingURL=separate-time-picker.component.css.map */
